'use client';
import { ContentBlock } from '@/payload-types';
import { CMSLink } from '../CMSLink';
import { useLocalityService } from '@/providers/Locality';
import RichText from './LocalityRichText';

const ProductCallToAction: React.FC<ContentBlock> = (data) => {
  const { columns } = data;

  const localityService = useLocalityService();

  localityService?.replaceTagsInContent(data);

  return (
    localityService && (
      <div className="mx-auto bg-white xsmall:py-20 lg:py-16">
        <div className="mx-auto flex max-w-5xl justify-center px-6 lg:px-8">
          <div className="mx-auto flex max-w-2xl flex-col items-center justify-center text-center lg:mx-0">
            {columns &&
              columns.map((data, index) => (
                <div key={index}>
                  {data.richText && <RichText data={data.richText} />}
                  {data.link && (
                    <CMSLink
                      {...data.link}
                      className="mt-5 rounded-md bg-[#0079AD] px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-[#005E87] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0079AD]"
                    />
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  );
};

export { ProductCallToAction };
